import * as React from 'react';

import Navbar from "../../Layouts/Navbar";

import {BiCategoryAlt} from "react-icons/bi";

import API from "../../Services/API";
import {toast} from "react-toastify";
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";
import {useNavigate} from "react-router-dom";

import { Fade } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css'
import LogoPic from "../../Assets/Images/logo.png";
import {FaMapMarker, FaMapMarkerAlt} from "react-icons/fa";



export default function Home() {
    const navigate = useNavigate();

    const [productGroups, setProductGroups] = React.useState([]);
    const [slides, setSlides] = React.useState([]);
    const [isLoaded, setIsLoaded] = React.useState(false);
    const [user , setUser] = React.useState([]);

    React.useEffect(() => {
        window.localStorage.removeItem("fromSearch");
        const params = {
            count : 48,
            orderBy : 'priority',
            orderType : 'desc',
            slideshow_id : 3
        }
        API.getProductGroups(params)
            .then((response) => {
                setProductGroups(response.data);

                API.getSlides(params)
                    .then((response) => {
                        setSlides(response.data);
                        setIsLoaded(true);
                    })
                    .catch((error) => {
                        if(error.response) {
                            toast.error(error.response.data.message);
                        }
                        else {
                            toast.error(error.message);
                        }
                    });

            })
            .catch((error) => {
                if(error.response) {
                    toast.error(error.response.data.message);
                }
                else {
                    toast.error(error.message);
                }
            });



    }, []);


    React.useEffect(() => {

        API.getUserInfo()
            .then((response) => {
                setIsLoaded(true);
                setUser(response.data.user);
            })
            .catch((error) => {
                if (error.response) {
                  //  toast.error(error.response.data.message);
                } else {
                    // toast.error(error.message);
                }
            });

        
    }, []);

    return (
        <React.Fragment>
            <Toast />
            {
                !isLoaded && <Loading />
            }
            {/*Search*/}
            <section className="container-fluid  py-3 rtl px-2 ">
                <div className="row search-city mx-2">
                    <div className="col-9 "
                         onClick={
                             () => {
                                 navigate(`/search`);
                             }
                         }
                    >
                        <img src={LogoPic} alt="پخش من" className="mx-1 " width='30'/>
                        <span className='text-dark text-small-3 pe-3'>
                            جستجو در

                                 پخش من

                        </span>
                    </div>
                    <div className="col-3 text-start text-small-2 text-dark"
                         role={'button'} onClick={() => {
                             navigate('/edit-profile')
                    }}
                    >
                        {
                            user.cityName ?
                                <>
                                    <FaMapMarkerAlt className='mx-1' />
                                    {user.cityName}
                                </> :
                                 <>
                                     &nbsp;
                                 </>
                        }

                    </div>

                </div>
            </section>
            {/*Slideshow*/}
            <div className="slide-container px-3">
                <Fade>
                    {slides.map((slide) => (
                        <div key={slide.id} onClick={() => {
                            navigate(`/vendor/${slide.link}`);
                        }}>
                           {/* <h2>{slide.name}</h2>*/}
                            <img style={{ width: '100%' }} src={slide.image} alt={slide.name}  className='slide-image'/>
                        </div>
                    ))}
                </Fade>
            </div>

            {/*Categories*/}
            <section className="container-fluid  mt-3 py-2 rtl px-0  ">
                <div className="row mx-1">
                    <div className="col-12 home-separator-text ">
                        <BiCategoryAlt className='mx-2' />
                        دسته بندی ها
                    </div>
                </div>
                <div className="row mx-2 pb-5 mb-3">
                    {
                        productGroups.map (group => {
                        return (
                            <div className="col-4 text-center product-group" key={group.id}
                            onClick={
                                () => {
                                    navigate(`/home/vendors/${group.id}`);
                                }
                            }
                            >
                                <div className="group-image-container">
                                    <img src={group.image} alt={group.name}/>
                                    <div className="title mt-2">

                                        {group.name.substring(0, 22)}
                                        {
                                            group.name.length > 22 ?
                                                <span className='text-small-4'>
                                                    ...
                                                </span>
                                                : ''
                                        }
                                    </div>
                                </div>

                            </div>
                        )} )

                    }

                </div>
            </section>

            <Navbar />
        </React.Fragment>
    );
};
